import './App.css';
import { Store } from './store';
import Home from './pages/home';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './pages/login';
import Register from './pages/register';
import Main from './pages/main';
import Profile from './pages/profile';
import Settings from './pages/settings';
import Terms from './pages/terms';
import Privacy from './pages/privacy';
import Global from './pages/global';
import freeGlobal from './pages/freeGlobal';

function App() {
  return (
    <div className='App'>
      <Store>
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/register' component={Register} />
            <Route exact path='/main' component={Main} />
            <Route exact path='/profile/:id' component={Profile} />
            <Route exact path='/settings' component={Settings} />
            <Route exact path='/terms-condition' component={Terms} />
            <Route exact path='/privacy' component={Privacy} />
            <Route exact path='/global' component={Global} />
            <Route exact path='/global-free' component={freeGlobal} />
            <Route exact path='*' component={Home} />
          </Switch>
        </BrowserRouter>
      </Store>
    </div>
  );
}

export default App;
